<template>
  <app-step-template :step="3">
    <template #title>
      Add Dependent
    </template>
    <template #buttons>
      <async-button
        v-if="!isInternalUser"
        type="button"
        :executing="savingDraft"
        class='btn lips --sm'
        @clicked="$emit('saveDraftClicked')"
      >
        <template #buttonContent>
          <span>Save Draft</span>
        </template>
      </async-button>
      <a @click="$router.go(-1)" class='_mlxs btn lips --sm'>Cancel</a>
    </template>
    <template #content>
      <slot></slot>
    </template>
  </app-step-template>
</template>

<script>
  import AppStepTemplate from './StepTemplate.vue'
  import AsyncButton from '@molecules/AsyncButton.vue'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      AppStepTemplate,
      AsyncButton
    },
    props: {
      savingDraft: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters(['isInternalUser'])
    }
  }
</script>
